import { FooterProps } from './Footer';

export const mapFooterData = (data): FooterProps => {
  const logoUrl: string = data?.logo?.url ?? '';

  const footerColumns =
    data?.footer_column_navigation?.map((column) => {
      const links =
        column.links?.map((item) => {
          const linkObj = item.link?.[0] ?? {};

          return {
            ariaLabel: item.aria_label || '',
            title: item.title || '',
            url: linkObj.url || '',
          };
        }) || [];

      return { links };
    }) || [];

  const secondaryNavigation =
    data?.secondary_navigation?.map((item) => {
      const linkObj = item.link?.[0] ?? {};

      return {
        ariaLabel: item.aria_label || '',
        title: item.title || '',
        url: linkObj.url || '',
      };
    }) || [];

  const copyright: string | undefined = data?.copyright ?? undefined;
  const legalInfo = data?.legalInfo;

  return {
    logoUrl,
    legalInfo,
    footerColumns,
    secondaryNavigation,
    copyright,
    description: data.description,
  };
};
